<h1 mat-dialog-title>Alerting test results</h1>
<div mat-dialog-content>
  <pre>
    {{data}}
  </pre>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</div>
